module.exports = __webpack_public_path__ + "static/media/GettyImages-1061328872-e2ad8c47a8ed4e23a46999635be12315.1ba9a671.jpg";